module.exports = __webpack_public_path__ + "front/img/gift_wechat.27167e0d.png";